export default {
  presenter: 'miler',
  title: 'Proč si nepamatovat hesla a co jsou to password managery',
  subtitle: 'začátečníci',
  text: `
Krátká přednáška o bezpečnosti hesel a o tom, proč je dobré si hesla vůbec nepamatovat a proč
raději používat password manager.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/miler-hesla.js